import R from 'ramda'

const FACEBOOK_ONETIME_OPTOUT_DISPLAY_TYPE = 'Opt FB User out'
const FACEBOOK_ONETIME_OPTOUT_WIDGET_TYPE = 'FB_OPT_OUT_ONE_TIME'

const isFacebookOneTimeWidgetOptOutAction = R.propEq(
  'type',
  FACEBOOK_ONETIME_OPTOUT_WIDGET_TYPE
)

const isPlainTextResponse = R.pipe(
  R.prop('success'),
  R.head,
  R.pathSatisfies(R.complement(R.either(R.isNil, R.isEmpty)), [
    'message',
    'message',
    'text'
  ])
)

const constructPlainTextResponse = R.path([
  'success',
  0,
  'message',
  'message',
  'text'
])

const constructTemplateResponse = R.pipe(
  R.prop('success'),
  R.head,
  R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'subtitle'
  ])
)

const constructGenericTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_OPTOUT_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  fbOptOutOneTimeAutoResponseText: R.cond([
    [isPlainTextResponse, constructPlainTextResponse],
    [R.T, constructTemplateResponse]
  ]),
  fbOptOutOneTimeAutoResponseImageUrl: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'image_url'
    ])
  ),
  templateTitle: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'title'
    ])
  ),
  templateActionUrl: R.pipe(
    R.prop('success'),
    R.head,
    R.pathOr('', [
      'message',
      'message',
      'attachment',
      'payload',
      'elements',
      0,
      'default_action',
      'url'
    ])
  )
})

const constructCustomTemplateAction = R.applySpec({
  type: R.always(FACEBOOK_ONETIME_OPTOUT_DISPLAY_TYPE),
  customDmTemplate: R.pipe(
    R.pipe(
      R.prop('success'),
      R.head,
      R.prop('message'),
      R.applySpec({ message: R.prop('message') })
    ),
    JSON.stringify
  ),
  action: R.always('TEMPLATE_CUSTOM')
})

const convertFacebookOptOutToFormAction = R.cond([
  [
    R.pathSatisfies(R.equals(true), ['success', 0, 'isCustomTemplate']),
    constructCustomTemplateAction
  ],
  [R.T, constructGenericTemplateAction]
])

export {
  isFacebookOneTimeWidgetOptOutAction,
  convertFacebookOptOutToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-onetime-optout.js